import { RichText } from '@graphcms/rich-text-react-renderer';
import { AssetReference, Reference, RichTextContent } from '@graphcms/rich-text-types';
import { elements } from './templates';

export const RichTextRenderer = ({
  content,
  references,
}: {
  content: RichTextContent;
  references?: unknown[];
}) => {
  return (
    <>
      <RichText
        content={content}
        references={references as (Reference | AssetReference)[]}
        renderers={{
          ...elements,
        }}
      />
    </>
  );
};
